import {
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Avatar,
    IconButton,
    Typography,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

export default function AvatarDialog({ handleClose, handleClickAvatar }) {
    return (
        <Dialog 
            open={true} 
            onClose={handleClose}
            PaperProps={{
                sx: {
                    borderRadius: '16px',
                    padding: 1,
                    maxWidth: '480px'
                }
            }}
        >
            <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>Choose Avatar</Typography>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{ color: (theme) => theme.palette.grey[500] }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ borderColor: '#F3F4F6' }}>
                <Grid container spacing={2} sx={{ py: 1 }}>
                    {[...Array(10)].map((ele, index) => (
                        <Grid
                            item
                            xs={4}
                            sm={2.4}
                            key={index}
                            sx={{ 
                                display: 'flex', 
                                justifyContent: 'center',
                                transition: 'transform 0.2s ease',
                                '&:hover': { 
                                    transform: 'scale(1.1)',
                                    cursor: "pointer" 
                                } 
                            }}
                            onClick={() => handleClickAvatar(`avatar_${index + 1}`)}
                        >
                            <Avatar
                                sx={{ 
                                    width: 64, 
                                    height: 64, 
                                    border: '2px solid #F3F4F6',
                                    '&:hover': {
                                        borderColor: '#2259c9'
                                    }
                                }}
                                alt={`avatar_${index + 1}`}
                                src={`/assets/avatars/avatar_${index + 1}.png`}
                            />
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>

            <DialogActions sx={{ p: 2 }}>
                <Button 
                    onClick={handleClose} 
                    variant="outlined"
                    sx={{ 
                        borderRadius: '10px', 
                        textTransform: 'none', 
                        fontWeight: 600,
                        px: 3,
                        color: '#374151',
                        borderColor: '#E5E7EB',
                        '&:hover': {
                            borderColor: '#D1D5DB',
                            backgroundColor: '#F9FAFB'
                        }
                    }}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
}
